export default "__VITE_ASSET__CEU2Rzaj__"